import * as yup from 'yup';
import { eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';

export const SingleFieldValidationSchemaGenerator = (transaction_category: eTransactionCategory, fieldName: string) => {
  switch (fieldName) {
    case 'loan_amount':
      if (transaction_category === eTransactionCategory.Purchase) {
        return yup.number().nullable();
      }
      return yup.number().nullable().required();
    case 'estimated_property_value':
      return yup.number().nullable();
    case 'purchase_price':
      if (transaction_category === eTransactionCategory.Purchase) {
        return yup.number().nullable().required();
      }
      return yup.number().nullable();
    case 'loan_number':
      return yup.string().nullable().required();
  }
  throw Error('Not supported field');
};
